// Services
import localStorageService from '../utils/services/localStorage/localStorage';

// Constants
import {
    DEBUG_DISABLE_CACHE_LOCAL_STORAGE_KEY,
    DEBUG_DISABLE_LOCAL_CACHE_RESET_LOCAL_STORAGE_KEY,
    DEBUG_LOCAL_STORAGE_KEY,
    DEBUG_TOOLBAR_LOCAL_STORAGE_KEY,
} from './debugConstants';

export const shouldDisableCache = () => localStorageService.getItem(DEBUG_DISABLE_CACHE_LOCAL_STORAGE_KEY) === 'true';

export const shouldDisableLocalCacheReset = () =>
    localStorageService.getItem(DEBUG_DISABLE_LOCAL_CACHE_RESET_LOCAL_STORAGE_KEY) === 'true';

export const shouldEnableDebugFeatures = () =>
    localStorageService.getItem(DEBUG_LOCAL_STORAGE_KEY) === 'true' || process.env.APPLICATION_MODE === 'development';

export const shouldShowDebugToolbar = () => localStorageService.getItem(DEBUG_TOOLBAR_LOCAL_STORAGE_KEY) === 'true';

let debugEnabled = false;

export const enableDebug = () => {
    debugEnabled = true;
};

export const isDebugEnabled = () => debugEnabled;
